//Наработки Давра
var urlBeforeNavigator = '';

$(function(){
    const compensateScrollbar = (on = true) => {
        if (on) {
            $('body, .b-sidebar__toggles, .justwidget').addClass('compensate-scrollbar');
        } else {
            $('body, .b-sidebar__toggles, .justwidget').removeClass('compensate-scrollbar');
        }

    };

    $(".b-sidebar").each(function(){
        var $sidebar = $(this),
          $page = $('.b-page'),
          $sidebarToggle = $('.b-sidebar__toggle', $sidebar),
          $sidebarScreens = $('.b-sidebar__hidden-screen', $sidebar);

        let compensateTimer;

        $sidebarToggle.on('click', function() {
            var dataToggle = $(this).attr('data-toggle'),
              targetScreen = $sidebar.find('.b-sidebar__hidden-screen[data-toggle='+dataToggle+']');

            if (window.JustWidget) {
                window.JustWidget.toggleWidget(false);
            }

            clearTimeout(compensateTimer);

            if ($page.hasClass('is-sidebar-open')) {
                if($(this).hasClass('is-active')) {
					
					if(dataToggle === 'search') {
                        clearSearch(false, false, { disable_history: 'Y' });
                        //Мой вариант
                        //var currentHref = window.location.href.replace('navigator/','');
                        //var removeNavigatorHref = currentHref.substring(0, currentHref.indexOf('?'));
                        //location.href = removeNavigatorHref;

                        //Наработки Давра
                        if(urlBeforeNavigator) {
                            history.replaceState({}, '', urlBeforeNavigator);
                        } else {
                            location.href = '/';
                        }
                    }
					
                    $(this).removeClass('is-active');
                    $sidebarScreens.fadeOut(300, function () {
                        compensateTimer = setTimeout(() => {
                            compensateScrollbar(false);
                            $page.removeClass('is-sidebar-open');
                        }, 300)

                    });
                    $page.attr('data-sidebar', '');
                    $('body').removeClass('has-navigator-result');

                    
                } else {
                    compensateScrollbar(true);
                    $sidebarToggle.removeClass('is-active');
                    $(this).addClass('is-active');
                    $sidebarScreens.fadeOut();
                    targetScreen.fadeIn();
                    $page.attr('data-sidebar', dataToggle);
                }
            } else {
                compensateScrollbar(true);

                $(this).addClass('is-active');
                $page.addClass('is-sidebar-open');
                $page.attr('data-sidebar', dataToggle);
                targetScreen.fadeIn();

                if(dataToggle === 'search') {
                    //Наработки Давра
                    urlBeforeNavigator = location.href;
                    history.replaceState('', '', '/navigator/');
                    targetScreen.find('.b-navigator-search__field').focus();
                }
            }
        });
        document.addEventListener("justwidget_toggle", function(event) {
            if (event.detail) {
                $sidebarToggle.removeClass('is-active');
                $sidebarScreens.fadeOut();
                clearTimeout(compensateTimer);
                compensateScrollbar(false);
                $page.attr('data-sidebar', '');
            }

            if($(window).width() > 479) {
                if(event.detail) {
                    $('body').addClass('is-blurred')
                } else {
                    $('body').removeClass('is-blurred')
                }
            }
        });

        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);

        $(window).on('resize', function(){
            if($(window).width() < 480) {
                let vh = window.innerHeight * 0.01;
                document.documentElement.style.setProperty('--vh', `${vh}px`);
                $('body').removeClass('is-blurred');
            } else if($('.b-sidebar__bot').find('.justwidget').length && !$('.b-sidebar__bot').find('.justwidget').hasClass('justwidget_hidden')) {
                $('body').addClass('is-blurred')
            }
        });
    });
});
